import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=61e0ac70&scoped=true&"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgottenPassword.vue?vue&type=style&index=0&id=61e0ac70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e0ac70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e0ac70')) {
      api.createRecord('61e0ac70', component.options)
    } else {
      api.reload('61e0ac70', component.options)
    }
    module.hot.accept("./ForgottenPassword.vue?vue&type=template&id=61e0ac70&scoped=true&", function () {
      api.rerender('61e0ac70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Auth/ForgottenPassword.vue"
export default component.exports